<app-top-menu></app-top-menu>
<main>
    <!-- Hero Section -->
    <section class="hero-section">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <h1 class="hero-title fade-up">Smarter Oversight.<br>Sharper Compliance.</h1>
                    <p class="hero-description fade-up" style="transition-delay: 0.15s;">
                        TAMA is a centralized digital system that monitors, manages,
                        and optimizes tax audit operations end to end. It acts as an
                        oversight and coordination layer, ensuring that every audit
                        case is properly initiated, tracked, executed, and concluded
                        transparently and efficiently.
                    </p>
                    <button [routerLink]="'/tama/registration'" class="btn-agent fade-up" style="transition-delay: 0.3s;">
                        Become an Agent <span class="arrow">→</span>
                    </button>
                </div>
                <div class="col-lg-6">
                    <div class="dashboard-area">
                        <!-- Cases Tracked Card -->
                        <div class="card-cases scale-in" style="transition-delay: 0.3s;">
                            <span class="label">Cases Tracked</span>
                            <div class="dot"></div>
                            <svg class="chart-svg" viewBox="0 0 200 50" fill="none">
                                <path class="chart-path" d="M0 40 Q30 35 50 30 T100 20 T150 15 T200 5" stroke="#8a7a30" stroke-width="2" fill="none"/>
                            </svg>
                            <div class="growth">68.5% Growth</div>
                        </div>

                        <!-- Alerts Today Card -->
                        <div class="card-alerts scale-in" style="transition-delay: 0.5s;">
                            <div class="label">Alerts Today</div>
                            <div class="number" id="alertCount">0</div>
                            <span class="date-tag">{{ today | date: 'dd MMM' }}</span>
                        </div>

                        <!-- Officers Monitored Card -->
                        <div class="card-officers scale-in" style="transition-delay: 0.7s;">
                            <div class="percentage" id="officerPercent">0%</div>
                            <div class="sub-label">Officers Monitored</div>
                            <div class="progress-bar-custom">
                                <div class="progress-fill" id="progressFill"></div>
                            </div>
                            <div class="progress-meta">
                                <span>65.5% Increase</span>
                                <span>Last Week</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Why TAMA Section -->
    <section class="why-section">
        <div class="container">
            <div class="why-card fade-up">
                <div class="row g-4">
                    <div class="col-lg-4">
                        <div class="why-image-wrapper">
                            <img src="/assets/img/tama-landing.png" alt="TAMA digital infrastructure illustration" loading="lazy">
                        </div>
                    </div>
                    <div class="col-lg-8">
                        <div class="why-content-card slide-right mb-3"
                             [class.active]="activeInfo === 'WHY_TAMA'"
                             style="transition-delay: 0.2s;"
                             (click)="activeInfo = 'WHY_TAMA'"
                        >
                            <h3 class="title">
                                Why TAMA
                                <span class="toggle-icon">{{ activeInfo === 'WHY_TAMA' ? '−' : '+' }}</span>
                            </h3>
                            <div *ngIf="activeInfo === 'WHY_TAMA'">
                                <p class="intro-text">
                                    The Tax Audit Monitoring Agent plays a critical role in strengthening revenue administration by:
                                </p>
                                <ul class="check-list">
                                    <li>
                                        <svg class="check-icon" viewBox="0 0 24 24" fill="none">
                                            <circle cx="12" cy="12" r="10" stroke="#c9a84c" stroke-width="2"/>
                                            <path d="M8 12l3 3 5-5" stroke="#c9a84c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        Enhancing transparency in audit processes
                                    </li>
                                    <li>
                                        <svg class="check-icon" viewBox="0 0 24 24" fill="none">
                                            <circle cx="12" cy="12" r="10" stroke="#c9a84c" stroke-width="2"/>
                                            <path d="M8 12l3 3 5-5" stroke="#c9a84c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        Reducing leakages and untracked audit cases
                                    </li>
                                    <li>
                                        <svg class="check-icon" viewBox="0 0 24 24" fill="none">
                                            <circle cx="12" cy="12" r="10" stroke="#c9a84c" stroke-width="2"/>
                                            <path d="M8 12l3 3 5-5" stroke="#c9a84c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        Improving efficiency and turnaround time
                                    </li>
                                    <li>
                                        <svg class="check-icon" viewBox="0 0 24 24" fill="none">
                                            <circle cx="12" cy="12" r="10" stroke="#c9a84c" stroke-width="2"/>
                                            <path d="M8 12l3 3 5-5" stroke="#c9a84c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        Strengthening oversight and control mechanisms
                                    </li>
                                    <li>
                                        <svg class="check-icon" viewBox="0 0 24 24" fill="none">
                                            <circle cx="12" cy="12" r="10" stroke="#c9a84c" stroke-width="2"/>
                                            <path d="M8 12l3 3 5-5" stroke="#c9a84c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        Driving higher revenue realization (IGR growth)
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="why-content-card slide-right"
                             [class.active]="activeInfo === 'COMPLIANCE_REQ'"
                             style="transition-delay: 0.4s;"
                             (click)="activeInfo = 'COMPLIANCE_REQ'"
                        >
                            <h3 class="title">
                                Compliance Requirements:
                                <span class="toggle-icon">{{ activeInfo === 'COMPLIANCE_REQ' ? '−' : '+' }}</span>
                            </h3>

                            <div *ngIf="activeInfo === 'COMPLIANCE_REQ'">
                                <ul class="check-list">
                                    <li>
                                        <svg class="check-icon" viewBox="0 0 24 24" fill="none">
                                            <circle cx="12" cy="12" r="10" stroke="#c9a84c" stroke-width="2"/>
                                            <path d="M8 12l3 3 5-5" stroke="#c9a84c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        Company Profile
                                    </li>
                                    <li>
                                        <svg class="check-icon" viewBox="0 0 24 24" fill="none">
                                            <circle cx="12" cy="12" r="10" stroke="#c9a84c" stroke-width="2"/>
                                            <path d="M8 12l3 3 5-5" stroke="#c9a84c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        CAC Documents and Particulars of Partners/Directors
                                    </li>
                                    <li>
                                        <svg class="check-icon" viewBox="0 0 24 24" fill="none">
                                            <circle cx="12" cy="12" r="10" stroke="#c9a84c" stroke-width="2"/>
                                            <path d="M8 12l3 3 5-5" stroke="#c9a84c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        Evidence of Registration with relevant or professional bodies
                                    </li>
                                    <li>
                                        <svg class="check-icon" viewBox="0 0 24 24" fill="none">
                                            <circle cx="12" cy="12" r="10" stroke="#c9a84c" stroke-width="2"/>
                                            <path d="M8 12l3 3 5-5" stroke="#c9a84c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        Copy of Financial Statement for the last 3 years
                                    </li>
                                    <li>
                                        <svg class="check-icon" viewBox="0 0 24 24" fill="none">
                                            <circle cx="12" cy="12" r="10" stroke="#c9a84c" stroke-width="2"/>
                                            <path d="M8 12l3 3 5-5" stroke="#c9a84c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        Evidence of Tax Clearance (TCC Certificate)
                                    </li>
                                    <li>
                                        <svg class="check-icon" viewBox="0 0 24 24" fill="none">
                                            <circle cx="12" cy="12" r="10" stroke="#c9a84c" stroke-width="2"/>
                                            <path d="M8 12l3 3 5-5" stroke="#c9a84c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        Evidence of payment for Business Premises
                                    </li>
                                    <li>
                                        <svg class="check-icon" viewBox="0 0 24 24" fill="none">
                                            <circle cx="12" cy="12" r="10" stroke="#c9a84c" stroke-width="2"/>
                                            <path d="M8 12l3 3 5-5" stroke="#c9a84c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        Evidence of Annual Returns Filling
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

</main>
<app-footer></app-footer>
